export const isEmpty = object => {
  return !Object.keys(object).find(key => object.hasOwnProperty(key))
}



// WEBPACK FOOTER //
// ./src/utils/objectIsEmpty.ts